import { getStyleVariantClass } from "@thelabnyc/thelabui/src/utils/styles";

import type { ClassNames as CocoonClassNames } from "../styles/composable/typography.cocoon.module.scss";
import styles from "../styles/composable/typography.module.scss";

/**
 * Every typography class exists only in a site variant of the module (the
 * base is neutral). `styles` is already the site's variant at module load (the
 * build swaps the import), so each resolves to the hashed class on sites with
 * a variant and `undefined` elsewhere. The keys are typed against the variant
 * `.d.ts` files.
 */
const variantClass = (key: CocoonClassNames): string | undefined =>
    getStyleVariantClass<string>(styles, key);

export const CAPTION_MEDIUM_CLASS_NAME = variantClass("captionMedium");

export const CAPTION_LIGHT_CLASS_NAME = variantClass("captionLight");

export const LINK_CLASS_NAME = variantClass("link");
